<template>
  <div class="mt-28 px-8">
    <b-modal
      id="isshowReview"
      size="sm"
      centered
      hide-header
      modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey"
      hide-footer
      class="overflow-y-hidden"
    >
      <div class="text-center text-black fsize25px font-medium header-font">
        <h1 class="col-black sm-fsize20">Your opinion matters to us!</h1>
      </div>
      <div class="mx-4">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div>
            <label>Activity form</label>
          </div>
          <el-input
            type="textarea"
            placeholder="Leave a message,if you want"
            width="50px"
            rows="5"
            v-model="description"
            class="justify-center bg-f3f3f3"
          >
          </el-input>
        </el-form>
        <div class="text-center fsize20px font-medium text-opax pt-4">
          <h1 class="fsize15 sm-fsize14">Experience with our Caretaker!</h1>
        </div>
        <b-form-rating
          id="rating-inline"
          inline-value="4"
          size="sm"
          v-model="value"
          color="#f3ca63"
          class="border-none w-1/2 m-auto mb-4"
        ></b-form-rating>
        <div class="rate-btn flex justify-center mt-4">
          <b-button variant="primary" @click="handleRate()">Rate Now</b-button>
        </div>
      </div>

      <div class="border-footer pt-6"></div>

      <div
        class="text-center text-opax letter-space fsize20px font-semibold"
        style="cursor: pointer"
        @click="$bvModal.hide('isshowReview')"
      >
        <p><b>May be later</b></p>
      </div>

      <template slot="footer"> <div></div> </template>
    </b-modal>

    <div class="booking-head fsize25px mb-8">
      <h1><b class="col-black">My Transactions</b></h1>
    </div>
    <div class="flex justify-end mb-5">
      <button class="bg-primary py-2 text-white rounded fsize18 px-8">
        <download-excel
          class="mr-1 flex"
          default-value=""
          :fetch="fetchData"
          :fields="json_fields"
          worksheet="My Worksheet"
          name="My_transactions.xls"
        >
          <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
          >Export
        </download-excel>
      </button>
    </div>
    <el-table border :data="get_allbookingvol.result" style="width: 100%">
      <!-- <el-table-column prop="time" label="Service id"></el-table-column> -->
      <el-table-column prop="time" label="Service Provider" v-slot="{ row }">{{
        row.volunteerId ? row.volunteerId.userId.firstname : "-"
      }}</el-table-column>
      <el-table-column prop="time" label="Name" v-slot="{ row }">{{
        row.userId.firstname
      }}</el-table-column>
      <el-table-column prop="time" label="Service" v-slot="{ row }">{{
        row.volunteerId ? row.volunteerId.service : "-"
      }}</el-table-column>
      <el-table-column prop="invoiceId" label="Invoice ID" v-slot="{ row }">{{
        row.paymentInfo ? row.paymentInfo.invoiceId : "Offline Payment"
      }}</el-table-column>
      <el-table-column prop="price" label="Amount" v-slot="{ row }">{{
        row.price
      }}</el-table-column>
      <el-table-column
        prop="date"
        label="Date"
        sortable=""
        width="190"
        v-slot="{ row }"
      >
        {{
          new Date(row.date).toLocaleDateString("en-IN", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        }}</el-table-column
      >
      <el-table-column prop="time" label="Time" width="190"></el-table-column>
      <el-table-column
        prop="status"
        label="Status"
        width="200"
      ></el-table-column>

      <!-- <el-table-column label="Review">
        <template slot-scope="scope">
          <el-button
            v-b-modal.isshowReview
            type="text"
            size=""
            @click="handleSubmit(scope)"
            >Write a Review</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        @change="handlePageChange"
        :per-page="perPage"
        :total="total_row"
      ></base-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      ruleForm: {
        desc: "",
      },
      value: null,
      description: "",
      tableData: [
        {
          Name: "sahil",
          text: "caregiver",
          date: "22/01/2022",
          time: "10:00",
          status: "completed",
          date2: "25/01/2022",
        },
        {
          Name: "sumit",
          text: "caregiver",
          date: "22/01/2022",
          time: "10:00",
          status: "completed",
          date2: "25/01/2022",
        },
        {
          Name: "yash",
          text: "caregiver",
          date: "22/01/2022",
          time: "10:00",
          status: "completed",
          date2: "25/01/2022",
        },
      ],
      rules: {
        desc: [
          {
            required: true,
            message: "Please select activity resource ",
            trigger: "change",
          },
        ],
      },

      currentPage: 1,
      perPage: 5,
      row: {},
      total_row: 5,
    };
  },
  methods: {
    formatter(row, column) {
      return row.address;
    },
    async init() {
      let payload = {
        _id: this.user._id,
        limit: 5,
        offset: (this.currentPage - 1) * 5,
      };
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "respitecare/get_allbooking",
          payload
        );
        // console.log(data);
        this.total_row = this.get_allbookingvol.totalCount;
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },
    async handleSubmit(scope) {
      this.row = scope.row;
      // console.log(this.row);
    },
    async handleRate() {
      let payload = {
        review: this.description,
        rating: this.value,
        userId: this.user._id,
        volunteerId: this.row.volunteerId._id,
      };
      if (this.description != "") {
        try {
          let data = await this.$store.dispatch(
            "respitecare/createreview",
            payload
          );
          this.$swal.fire({
            title: "Thanks for rating",
            // text: err,
            icon: "success",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.row = {};
          this.description = "";
          this.value = "";
          this.$bvModal.hide("isshowReview");
        } catch (err) {
          this.$swal.fire({
            title: "Something went wrong",
            text: err,
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } else {
        this.$swal.fire({
          title: "Add a message",
          // text: err,
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
    async fetchData() {
      let payload = {};

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("respitecare/get_allbooking", {
          _id: this.user._id,
        });
        this.init();
        if (data.code == 200) {
          loader.close();
          this.$swal({
            // title: "No Selection!",
            html: `<p class="text-center">Data has been successfully exported!</p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
            // confirmButtonText: "Yes, delete it!",
          });
          return data.data.result;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("auth", { user: "user" }),
    ...mapState("respitecare", { get_allbookingvol: "get_allbookingvol" }),
    json_fields() {
      return {
        service_provider: "volunteerId.userId.firstname",
        name: `userId.firstname`,
        invoice_id: "paymentInfo.invoiceId",
        service: "volunteerId.service",
        amount: "paymentInfo.paymentAmt",
        date: {
          field: "date",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
        time: "time",
        status: "status",
        // created_at: {
        //   field: "createdAt",
        //   callback: (date) => {
        //     return new Date(date).toDateString();
        //   },
        // },
      };
    },
    // displayedPages() {
    //   return this.get_allbookingvol.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
  },
  async mounted() {
    await this.init();
  },
};
</script>

<style>
.el-table th > .cell {
  text-align: center;
  color: #000;
}
.el-table .cell {
  text-align: center;
}
.fsize25px {
  font-size: 25px;
}
.fsize20px {
  font-size: 20px;
}
.border-review-modal {
  border: 1px solid #eeedee;
  border-radius: 20px;
}
.space-border {
  padding: 18px 21px;
}
.text-opax {
  color: black;
  opacity: 80%;
}
.bg-f3f3f3 .el-textarea__inner {
  background: #f3f3f3;
}
.border-footer {
  border-bottom: 1px solid#f3f4f5;
}
.letter-space {
  padding: 10px 20px;
}
.header-font {
  padding: 13px 9px;
}
</style>
